import React from 'react';
import companyImage from '../assets/companyImage.png';

const CardCompanyIntro = () => {
  return (
    <div className="w-full bg-white py-10 sm:py-12  px-4 sm:px-6 ">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:gap-3 md:flex-row items-stretch">
          <div className="w-full md:w-1/2 h-full">
            <img src={companyImage} alt="Fonoaudiologia na Prática" className="w-full h-full object-cover rounded-md" />
          </div>

          <div className="w-full md:w-1/2 flex flex-col items-center md:items-start md:px-8">
            <h2 className="text-2xl text-gray-800 font-bold mt-10 md:mt-0 mb-4">Saiba mais sobre a empresa Fonoaudiologia na Prática LTDA</h2>
            <div className="mb-6">
              <h3 className="text-xl text-gray-800 font-semibold mb-2">Quem Somos:</h3>
              <p className="text-gray-700">
                Somos um trio de mulheres nordestinas apaixonadas pela Fonoaudiologia e especialistas em disfagia,
                com ampla experiência na Fonoaudiologia hospitalar. Unimos nossas vivências profissionais para
                empreender e criar um aplicativo que transforma a prática fonoaudiológica. Acreditamos firmemente
                que a tecnologia pode ser uma aliada poderosa, proporcionando praticidade e inovação no dia a dia
                dos profissionais.
              </p>
            </div>
            <div className="mb-6">
              <h3 className="text-xl text-gray-800 font-semibold mb-2">Nossa Missão:</h3>
              <p className="text-gray-700">
                Nossa missão é proporcionar soluções inovadoras em Fonoaudiologia, com foco na reabilitação em saúde,
                de forma a otimizar o trabalho dos fonoaudiólogos(as), promovendo um impacto positivo na vida dos pacientes
                e dos profissionais que cuidam deles.
              </p>
            </div>
            <div className="mb-6">
              <h3 className="text-xl text-gray-800 font-semibold mb-2">Nossos Valores:</h3>
              <ul className="text-gray-700 list-disc pl-5">
                <li className="mb-2">Empoderamento: acreditamos na força das mulheres e no impacto que podemos gerar juntas, inspirando outras pessoas.</li>
                <li className="mb-2">Inovação: Estamos comprometidas em trazer tecnologias que simplifiquem o cotidiano dos fonoaudiólogos e melhorem a experiência do paciente.</li>
                <li className="mb-2">Excelência: Buscamos sempre a excelência em nossos serviços, com base em nossa vasta experiência e especialização.</li>
                <li className="mb-2">Cuidado: Valorizamos o atendimento humanizado, priorizando sempre o bem-estar e a dignidade dos nossos pacientes.</li>
              </ul>
            </div>
            <div style={{ fontFamily: "Dancing Script" }} className="text-black text-lg px-0 font-dancing tracking-widest">
              <p className="font-semibold">Flávia Neves</p>
              <p className="font-semibold">Jessica Gomes</p>
              <p className="font-semibold">Amanda Nery</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CardCompanyIntro;
